import React from "react";
import { StoreAdminDetails } from "../../../../types/modules/admin/StoreAdmin.type";

type Props = {
  store: StoreAdminDetails;
};

const CoverAndLogo: React.FC<Props> = ({ store }) => {
  const { coverUrl, logoUrl, languages, sector } = store;
  const name = languages?.[0]?.name || "Unnamed Store";

  return (
    <div className="relative w-full  overflow-hidden shadow-custom-light">
      <div className="relative w-full h-60">
        {coverUrl ? (
          <img src={coverUrl} alt="Store Cover" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-gradient-to-r from-primary/50 to-secondary/50 flex items-center justify-center text-light font-bold text-xl">
            No Cover Image
          </div>
        )}

        <div className="absolute inset-0 bg-black/40"></div>

        <div className="absolute bottom-2 start-6 flex items-center gap-4">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Store Logo"
              className="w-32 h-32 rounded-full shadow-2xl border-4 border-white object-cover z-10"
            />
          ) : (
            <div className="w-32 h-32 rounded-full shadow-2xl border-4 border-white bg-primary flex items-center justify-center text-white text-3xl font-bold z-10">
              {name
                .split(" ")
                .map((w) => w[0])
                .join("")
                .toUpperCase()}
            </div>
          )}
          <div className="flex flex-col text-white z-10">
            <h1 className="text-2xl font-bold">{name}</h1>
            <p className="text-sm">{sector.languages[0]?.name || ""}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverAndLogo;
